import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
import { SnGridRef } from "@shared/components/GridV2/SnGridTypes";

interface Props {
  Menuprops: menuInfo;
}

const SN_MTL_EVL_REP_010 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region  variable
  const gridRefs = useRef<{ [key: string]: React.RefObject<SnGridRef> }>({
    grid1: React.createRef<SnGridRef>(),
  });

  const getGridCurrent = (key: string): SnGridRef => {
    const grid = gridRefs.current[key]?.current;
    if (!grid) {
      throw new Error(`Grid '${key}' is not mounted yet`);
    }
    return grid;
  };

  const searchRef = useRef<any>(null);

  //#region  Components useState
  const [formData, setFormData] = useState<any>(); // 조회조건 변수
  const [formControlData, setFormControlData] = useState<any[]>([]); // 조회조건 설정된 항목 binding

  const [columns, setColums] = useState<any>({
    grid1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
  });

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormControlData(rtn.formControlData); // 조회조건 항목 설정
        // 초기값에 공유로 받은 값이 있으면 덮어쓰지 않고 유지
        setFormData((prev: any) => ({
          ...(rtn.formData || {}),
          ...(prev || {}),
        }));

        setColums({
          grid1: rtn.grid.grid1,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  useImperativeHandle(ref, () => ({
    onSearch,
  }));

  //#region onSearch
  const onSearch = async (searchData: any) => {
    try {
      const searchDataToUse = searchData || searchRef.current.getFormdata();
      searchDataToUse.dt_from = searchDataToUse.dt_from.slice(0, 6);
      searchDataToUse.dt_to = searchDataToUse.dt_to.slice(0, 6);

      const is_date = searchDataToUse.dt_from + "15";

      const ls_mm = is_date.substring(4, 6);

      let ls_yy: string;
      if (Number(searchDataToUse.mm_bas) <= Number(ls_mm)) {
        ls_yy = is_date.substring(0, 4);
      } else {
        ls_yy = String(Number(is_date.substring(0, 4)) - 1);
      }

      const ls_yy_fr = String(Number(ls_yy) - 1);
      const ls_dt_bas = ls_yy_fr + "0101";

      // 필요하면 서버로 전달
      searchDataToUse.dt = is_date;
      searchDataToUse.dt_bas = ls_dt_bas;

      const params = {
        id: "sn_mtl_evl_rep_010_01",
        params: searchDataToUse,
      };

      const data: any = await fnGetDataSet(params);
      const baseDate = new Date(
        Number(is_date.substring(0, 4)),
        Number(is_date.substring(4, 6)) - 1,
        15
      );

      const headers: Record<string, string> = {};

      for (let i = 0; i <= 12; i++) {
        const dt = new Date(baseDate);
        dt.setMonth(dt.getMonth() - i);

        const ym = `${dt.getFullYear()}/${String(dt.getMonth() + 1).padStart(2, "0")}`;

        headers[`am_m${i}`] = i === 12 ? `${ym} 이전 수량` : `${ym} 수량`;
        headers[`am_m${i}_1`] = i === 12 ? `${ym} 이전 금액` : `${ym} 금액`;
      }

      setColums((prev: any) => ({
        ...prev,
        grid1: prev.grid1.map((col: any) => ({
          ...col,
          nm_column: headers[col.cd_column] ?? col.nm_column,
        })),
      }));

      const rows = data[0].map((row: any) => {
        const newRow = { ...row };

        for (let i = 0; i <= 12; i++) {
          newRow[`am_m${i}`] = row[`m${i}`];
          newRow[`am_m${i}_1`] = row[`m${i}_1`];
        }

        return newRow;
      });

      setDataSources({
        grid1: rows,
      });
      // setDataSources({
      //   grid1: data[0],
      // });
    } catch (error: any) {}
  };
  //#endregion

  //#region useMemo
  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
      },
    }),
    [columns, dataSources]
  );
  //#endregion

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>
      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnGrid
          ref={gridRefs.current["grid1"]} // Grid Name
          columnConfig={grids.grid1.columns} // 컬럼 설정 전달
          rowData={grids.grid1.dataSource} // Datasource
          etcProps={{
            rowSelection: "multiple",
            title: "",
            isEditable: false,
          }}
        />
      </div>
    </div>
  );
});

export default SN_MTL_EVL_REP_010;
